import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFocusOnFirstErrorField } from '../../hooks/errorFieldFocus';
import { useValidator } from '../../hooks/formValidator/useValidator';
import Button from '../../ui/Button';
import ButtonsGroup from '../../ui/ButtonsGroup';
import useInstitutionVerificationFormValidationSchema from './useValidationSchema';
import useInstitutionVerificationFormRefs from './useFormRefs';
import { useAppDispatch } from '../../store';
import { handleFileUploadChange } from '../AdminContentForms/helpers';
import useInstitutionVerificationFormState from './useFormState';
import FormFields from './formFields';
import { sendApprovalDocuments } from '../../api/admin/institution-verification';
import { setIsModalOpen, setModalContent } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
const InstitutionVerificationForm = ({ submitStatus, setSubmitStatus, }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { formState } = useInstitutionVerificationFormState();
    const { inputsValidationSchema, selectsValidationSchema } = useInstitutionVerificationFormValidationSchema();
    const { formErrors, validateAll, validateInputField, validateSelect } = useValidator({
        inputSchema: inputsValidationSchema,
        selectSchema: selectsValidationSchema,
    });
    const { refs, orderedRefs } = useInstitutionVerificationFormRefs();
    const [forceFocus, setForceFocus] = useState(false);
    useFocusOnFirstErrorField(formErrors, orderedRefs, forceFocus, setForceFocus);
    const handleUploadChange = (file) => {
        handleFileUploadChange({
            file,
            setFile: formState.setFile,
            fieldName: 'file',
        });
        validateSelect('file', !!file);
    };
    const handleSubmit = async () => {
        const errors = validateAll({
            inputValues: { message: formState.message },
            selectValues: { file: !!formState.file },
        });
        if (Object.keys(errors).length > 0) {
            setForceFocus(true);
            return;
        }
        setSubmitStatus('pending');
        try {
            await sendApprovalDocuments({
                approvalMessage: formState.message,
                file: formState.file,
            });
            setSubmitStatus('success');
        }
        catch (error) {
            setSubmitStatus('error');
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
        }
    };
    return (_jsxs("form", { className: 'institution-verification-form', onSubmit: (event) => event.preventDefault(), children: [_jsx("legend", { className: "title--2", children: t('admin.contact_uploads') }), _jsx(FormFields, { handleUploadChange: handleUploadChange, refs: refs, formErrors: formErrors, formState: formState, validateInputField: validateInputField }), _jsx("div", { className: "rally-form-submit", children: _jsx(ButtonsGroup, { children: _jsx(Button, { type: "submit", onClick: handleSubmit, label: t('button.submit'), disabled: submitStatus === 'pending' }) }) })] }));
};
export default InstitutionVerificationForm;
